(function () {
    'use strict';

    // @ngInject
    function BrandsControllerCtor($scope, $injector, AnalyticsService, ModalService, UsersManager, AppStates, DeviceService, AccountsService, Enums, NavigationService, $timeout) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'BrandsController';
        AnalyticsService.trackPageView(this, 'BrandsController');

        this.AppStates = AppStates;
        this.ModalService = ModalService;
        this.AccountsService = AccountsService;
        this.UsersManager = UsersManager;
        this.DeviceService = DeviceService;
        this.Enums = Enums;
        this.$timeout = $timeout;

        this.device = this.DeviceService.device;
        this.user = this.UsersManager.getCurrUser();
        this._buildBrandsList();

        NavigationService.registerPlusButtonCallback(this.addCompany.bind(this));

        $scope.$on('$destroy', () => {
           NavigationService.unregisterPlusButtonCallback();
        });
    }

    Controllers.BrandsController = Class(Controllers.BaseController, {
        constructor: BrandsControllerCtor,

        addCompany() {
            this.ModalService.openAddCompanyModal().then((values) => {
                this.$timeout(() => {
                    this._create(values.companyType, values.companyName);
                }, 200);
            });
        },

        switchCompany(companyId) {
            this.AccountsService.switchCompany(companyId);
        },

        _create(companyType, companyName) {
            this.AccountsService.createCompany(this.user.account_id, companyType, companyName).then((resp) => {
                return this.AccountsService.switchCompany(resp.data.company._id, true);
            }).then(() => {
                this.goToState(this.AppStates.root_core_navigation_settings_company_general);
            });
        },

        _buildBrandsList() {
            this.companies = [];
            this.user.companies.forEach((company) => {

                let _company = {
                    _id: company._id,
                    name: company.company_name,
                    icon_image: company.icon_image,
                    email: company.email
                };

                if (company._id === this.user.default_company_id) {
                    this.defaultCompany = _company;
                } else {
                    this.companies.push(_company);
                }
            });

            if (!this.defaultCompany) {
                this.defaultCompany = this.companies.pop();
            }
        }
    });
}());
